import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { icon: '📊', label: 'Dashboard', path: '/admin/dashboard' },
    { icon: '📦', label: 'Orders', path: '/admin/orders' },
    { icon: '🍴', label: 'Menu Management', path: '/admin/menu' },
    { icon: '👥', label: 'Customers', path: '/admin/customers' },
    { icon: '🎟️', label: 'Coupons', path: '/admin/coupons' },
    { icon: '📧', label: 'Contact Requests', path: '/admin/contact-requests' },
    { icon: '📊', label: 'Reports', path: '/admin/reports' },
    { icon: '⚙️', label: 'Settings', path: '/admin/settings' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('adminSession');
    sessionStorage.removeItem('adminSession');
    navigate('/admin');
  };

  const handleMenuClick = (path) => {
    navigate(path);
    if (window.innerWidth < 992) {
      onClose();
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">🍽️</div>
          <h2 className="sidebar-title">Restaurant Admin</h2>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item, index) => (
            <button
              key={index}
              className={`sidebar-menu-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => handleMenuClick(item.path)}
            >
              <span className="menu-icon">{item.icon}</span>
              <span className="menu-label">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-menu-item logout-item" onClick={handleLogout}>
            <span className="menu-icon">🚪</span>
            <span className="menu-label">Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;

